import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import React from 'react';
import logo from './logo.svg';
import './App.css';
import { withAuthenticator } from 'aws-amplify-react'; // or 'aws-amplify-react-native';
import Dashboard from './components/Dashboard';

Amplify.configure(awsconfig);


const signUpConfig = {
  header: 'My Customized Sign Up',
  hideAllDefaults: true,
  defaultCountryCode: '1',
  signUpFields: [
    {
      label: 'Email',
      key: 'username',
      required: true,
      displayOrder: 1,
      type: 'string'
    },
    {
      label: 'Password',
      key: 'password',
      required: true,
      displayOrder: 2,
      type: 'password'
    }
  ]
};

function App() {
  return (
    <Dashboard />
  );
}

export default withAuthenticator(App,{signUpConfig});
